/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export type KiteAnalyticsTrxTpsRequest = {
    period?: KiteAnalyticsTrxTpsRequest.period;
};

export namespace KiteAnalyticsTrxTpsRequest {

    export enum period {
        D7 = 'D7',
        D30 = 'D30',
        D90 = 'D90',
        ALL = 'ALL',
    }


}

